import { createSelector } from "@reduxjs/toolkit";
import { selectUserName } from "../userInfo/userInfoSlice";
import { isProdStage } from "../../util/stageUtils";
import { AwsRumConfig, AwsRum } from "aws-rum-web";

interface CloudWatchRumConfiguration {
  config: AwsRumConfig;
  applicationId: string;
  region: string;
  version: string;
}

const BetaRumCofig: CloudWatchRumConfiguration = {
  config: {
    sessionSampleRate: 1,
    identityPoolId: "us-west-2:8e1293b7-9112-4bdd-b7a8-be068429425b",
    guestRoleArn:
      "arn:aws:iam::581881012334:role/AsinCentral-CloudWatchRum-AsinCentralCloudWatchRumb-FC1qsDxLgn6g",
    telemetries: ["errors", "http", "performance"],
    allowCookies: true,
    enableXRay: true,
    signing: true,
  },
  applicationId: "70f01fdc-5e3a-4a62-b214-a1204b723719",
  region: "us-west-2",
  version: "1.0.0",
};

const ProdRumCofig: CloudWatchRumConfiguration = {
  config: {
    sessionSampleRate: 1,
    identityPoolId: "us-east-1:ccf9cfc2-c4d7-4bd5-9070-ab9ba2758dbf",
    guestRoleArn:
      "arn:aws:iam::487853185654:role/AsinCentral-CloudWatchRum-AsinCentralCloudWatchRump-vKeBFMtlqq6C",
    telemetries: ["errors", "http", "performance"],
    allowCookies: true,
    enableXRay: true,
    signing: true,
  },
  applicationId: "59c9b298-d7f1-4698-a57f-1ae9179a80f1",
  region: "us-east-1",
  version: "1.0.0",
};

const getCloudWatchRumConfiguration = (): CloudWatchRumConfiguration => {
  return isProdStage() ? ProdRumCofig : BetaRumCofig;
};

// Using a redux memoized selector on the userName because we want to instantiate the RUM client when the userInfo
// state is updated with the logged-in users alias etc
const selectRumClient = createSelector([selectUserName], (userName: string) => {
  if (userName === "") {
    return undefined;
  }

  const { config, applicationId, region, version } =
    getCloudWatchRumConfiguration();
  console.log(`Instantiating RUM client for ${userName}`);
  return new AwsRum(applicationId, version, region, {
    ...config,
    // IMPORTANT: userAlias attribute name is required
    sessionAttributes: { userAlias: userName },
  });
});

export default selectRumClient;
